/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
import { AvatarDropdown } from './RightContent/AvatarDropdown';
import { SelectLang } from './RightContent';
import ThemeSwitch from './ThemeSwitch';

export { AvatarDropdown, SelectLang, ThemeSwitch };
